import { post } from '@/utils/request'

/**
 * 增加文章
 * @param {String}  title   标题
 * @param {String} content 内容
 */
export function taoke_cms_help_add(data) {
  return post('taoke_cms_help_add', data)
}

/**
 * 修改文章
 * @param {String}  id   id
 * @param {String}  title   标题
 * @param {String} content 内容
 */
export function taoke_cms_help_edit(data) {
  return post('taoke_cms_help_edit', data)
}

/**
 * 删除文章
 * @param {String}  id   文章id
 */
export function taoke_cms_help_delete(data) {
  return post('taoke_cms_help_delete', data)
}

/**
 * 文章列表
 * @param {String}  page   页码
 * @param {String}  pagesize   页数
 */
export function taoke_cms_help_list(data) {
  return post('taoke_cms_help_list', data)
}

/**
 * 修改文章顺序
 * @param {String}  ids   id集合
 * @param {String}  id_order_str   页数
 */
export function taoke_cms_help_order_set(data) {
  return post('taoke_cms_help_order_set', data)
}

/**
 * 文章置顶
 * @param {String}  id   id
 */
export function taoke_cms_help_order_set_top(data) {
  return post('taoke_cms_help_order_set_top', data)
}

/**
 * 文章取消置顶
 * @param {String}  id   id
 */
export function taoke_cms_help_order_set_notop(data) {
  return post('taoke_cms_help_order_set_notop', data)
}